module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/ExtremelyHotDay/Nagano_ExtremelyHotDay_MRI_RCP85_End.png";